// Sayfa bazlı SEO meta yapılandırması.
// PageSEO bileşeni bu sabitleri react-helmet-async ile <head>'e basar.

import SITE from "./siteConfig";

const DEFAULT_OG_IMAGE = `${SITE.url}/last-updatedNewLogo.jpg`;

export const DEFAULT_SEO = {
  titleTemplate: (t) => (t ? `${t} | ${SITE.name}` : SITE.name),
  ogImage: DEFAULT_OG_IMAGE,
  locale: "tr_TR",
};

// Her route için: title, description, keywords, path (canonical), ogTitle
export const PAGE_SEO = {
  home: {
    title:
      "Üç Kardeşler Teknik Servis | Bursa Kombi, Klima & Beyaz Eşya Servisi",
    description:
      "Bursa Osmangazi merkezli 7/24 teknik servis. Kombi bakımı, petek temizliği, klima servisi ve beyaz eşya tamiri. Aynı gün servis için hemen arayın: 0553 803 64 75.",
    keywords:
      "bursa teknik servis, kombi servisi bursa, beyaz eşya tamiri bursa, klima servisi bursa, petek temizliği bursa, üç kardeşler teknik servis",
    path: "/",
  },
  services: {
    title: "Servislerimiz | Kombi, Klima, Beyaz Eşya Servisi - Bursa",
    description:
      "Kombi tamir ve bakımı, klima servisi, petek temizliği, çamaşır & bulaşık makinesi ve buzdolabı tamiri. Bursa genelinde profesyonel teknik servis hizmeti.",
    keywords:
      "kombi servisi bursa, klima servisi, petek temizliği, çamaşır makinesi tamiri, bulaşık makinesi tamiri, buzdolabı tamiri bursa",
    path: "/servislerimiz",
  },
  klimaBakimi: {
    title: "Klima Bakımı Bursa | Profesyonel Klima Servisi",
    description:
      "Bursa'da profesyonel klima bakımı ve servisi. Filtre temizliği, gaz kontrolü, performans testi. Sağlıklı hava ve enerji tasarrufu için hemen arayın.",
    keywords:
      "klima bakımı bursa, klima servisi bursa, klima temizliği, klima gaz dolumu",
    path: "/servislerimiz/klima-bakimi",
  },
  odaTermostati: {
    title: "Oda Termostatı Montajı Bursa | Akıllı Termostat Kurulumu",
    description:
      "Akıllı oda termostatı montajı ile kombinizde %20'ye varan tasarruf. Bursa'da profesyonel kurulum ve aynı gün montaj imkanı.",
    keywords:
      "oda termostatı bursa, akıllı termostat, kombi termostat montajı, kablosuz termostat",
    path: "/servislerimiz/oda-termostati",
  },
  about: {
    title: "Hakkımızda | Bursa'nın Güvenilir Teknik Servisi",
    description:
      "Üç Kardeşler Teknik Servis, Bursa'da yıllardır kombi, klima ve beyaz eşya servisinde uzman ekibiyle hizmet veren güvenilir teknik servis firmasıdır.",
    keywords:
      "üç kardeşler teknik servis, bursa teknik servis firması, hakkımızda",
    path: "/hakkimizda",
  },
  contact: {
    title: "İletişim | 7/24 Teknik Servis Bursa",
    description:
      "Üç Kardeşler Teknik Servis ile iletişime geçin. Telefon: 0553 803 64 75, WhatsApp ve e-posta ile 7/24 ulaşabilirsiniz. Osmangazi, Bursa.",
    keywords:
      "üç kardeşler iletişim, bursa teknik servis telefon, teknik servis whatsapp",
    path: "/iletisim",
  },
  location: {
    title: "Konum | Osmangazi Bursa Teknik Servis Adresi",
    description:
      "Üç Kardeşler Teknik Servis konumu: Çiftehavuzlar Mahallesi Uslu Sokak No:82A, Osmangazi/Bursa. Yol tarifi ve iletişim bilgileri.",
    keywords:
      "bursa teknik servis adres, osmangazi teknik servis, üç kardeşler konum",
    path: "/konum",
  },
  notFound: {
    title: "Sayfa Bulunamadı",
    description: "Aradığınız sayfa bulunamadı.",
    path: "",
  },
};

export default PAGE_SEO;
